import React from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseBtn,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  useModalContext,
} from '@fiverr-private/overlay';
import { ProgressBar } from '@fiverr-private/dynamic_matching';
import { I18n } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { Video } from '@fiverr-private/media';
import { List, ListItem } from '@fiverr-private/list';
import { AppI18n } from '../../i18n';

const CLOUDINARY_VIDEO_LINK =
  'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/7afa6a213ce2c95b5c012970966821ea-1726581298013/Buyers%20Dynamic%2016x9';
const sources = [
  {
    src: CLOUDINARY_VIDEO_LINK,
    type: 'video/mp4',
  },
];

const TRANSLATION_KEY = 'dm_brief_creation.how_to_modal';

export interface HowToModalProps {}

const CloseModal = () => {
  const { close } = useModalContext();

  return (
    <Button onClick={close}>
      <I18n k={`${TRANSLATION_KEY}.cta`} />
    </Button>
  );
};

export const HowToModal = ({ children }: React.PropsWithChildren<HowToModalProps>) => (
  <Modal fullScreenBreakpoint="sm">
    <ModalTrigger>{children}</ModalTrigger>
    <ModalContent size="xl">
      <ModalHeader>
        <AppI18n k="how_to_modal.title" />
        <ModalCloseBtn />
      </ModalHeader>
      <ModalBody>
        <Stack marginBottom="10" alignSelf={'center'} maxWidth={636} width="100%">
          <Video sources={sources} autoPlay={true} muted={true} ratio="16/9" />
        </Stack>
        <Stack marginBottom="4">
          <Heading as="h6">
            <AppI18n k="how_to_modal.progress.title" />
          </Heading>
        </Stack>
        <ProgressBar type="numeric" checkboxSize={'24px'} currentStep={2} connectingLine={false}>
          <Stack gap="0.5" direction="column" paddingLeft="2" paddingBottom="4">
            <Text fontWeight="bold">
              <AppI18n k="how_to_modal.progress.0.title" />
            </Text>
            <Text>
              <AppI18n k="how_to_modal.progress.0.subtitle" />
            </Text>
          </Stack>
          <Stack gap="0.5" direction="column" paddingLeft="2" paddingBottom="4">
            <Text fontWeight="bold">
              <AppI18n k="how_to_modal.progress.1.title" />
            </Text>
            <Text>
              <AppI18n k="how_to_modal.progress.1.subtitle" />
            </Text>
          </Stack>
          <Stack gap="0.5" direction="column" paddingLeft="2">
            <Text fontWeight="bold">
              <AppI18n k="how_to_modal.progress.2.title" />
            </Text>
            <Text>
              <AppI18n k="how_to_modal.progress.2.subtitle" />
            </Text>
          </Stack>
        </ProgressBar>
        <Stack marginTop="8" gap="0" direction="column" paddingLeft="0">
          <Stack marginBottom="4">
            <Heading as="h6">
              <AppI18n k="how_to_modal.describe_what_you_need.title" />
            </Heading>
          </Stack>
          <Stack>
            <Text>
              <AppI18n k="how_to_modal.describe_what_you_need.description" />
            </Text>
          </Stack>
          <List marginBottom="4" paddingX="0" paddingTop="2">
            <Stack>
              <ListItem backgroundColor="grey_200" paddingX="4" paddingY="2" borderRadius="lg">
                <Text>
                  <AppI18n k="how_to_modal.describe_what_you_need.description_list.example_1" />
                </Text>
              </ListItem>
            </Stack>
            <Stack>
              <ListItem backgroundColor="grey_200" paddingX="4" paddingY="2" borderRadius="lg">
                <Text>
                  <AppI18n k="how_to_modal.describe_what_you_need.description_list.example_2" />
                </Text>
              </ListItem>
            </Stack>
            <Stack>
              <ListItem backgroundColor="grey_200" paddingX="4" paddingY="2" borderRadius="lg">
                <Text>
                  <AppI18n k="how_to_modal.describe_what_you_need.description_list.example_3" />
                </Text>
              </ListItem>
            </Stack>
          </List>
        </Stack>
      </ModalBody>
      <ModalFooter>
        <CloseModal />
      </ModalFooter>
    </ModalContent>
  </Modal>
);
